<template>
  <div />
</template>

<script>
import ForeplayAPI from '@/api/foreplayServer'
export default {
  name: 'ExpertRedirectView',
  async mounted () {
    try {
      const response = await ForeplayAPI.Users.getExpertUserByUTM(this.$route.params.utm)
      const payload = response?.data
      if (response?.error || !payload?.expert) {
        this.$showAlert({
          message: response?.message || 'Invalid Expert',
          type: 'error'
        })

        return this.$router.push({ name: 'DiscoveryView' })
      }
      this.$router.push({
        name: 'DiscoveryExpertPublicView',
        params: { id: this.$route.params.utm }
      })
    } catch (error) {
      this.$showAlert({
        message: error.response?.data?.error || error.response?.data?.message || error.message || 'Unable to load this expert',
        type: 'error'
      })
      return this.$router.push({ name: 'DiscoveryView' })
    }
  }
}
</script>

<style scoped lang="sass"></style>
